<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import useAuthStore from '~/stores/auth'
import { useGreetings } from '~/composables/useGreetings'
import { useAppColor } from '~/composables/useAppColor'
import UpperPrimarySubjects from '~/components/home/upperPrimary/UpperPrimarySubjects.vue'
import SubscriptionBox from '~/components/home/SubscriptionBox.vue'
import DefaultMessages from '~/components/home/DefaultMessages.vue'
import BannerArticles from '~/components/home/BannerArticles.vue'

const { t } = useI18n()
const { user, isTeacher } = storeToRefs(useAuthStore())
const { greeting } = useGreetings()
const { themeColor } = useAppColor()
</script>

<template>
  <DefaultMessages class="-mb-24 mt-24 w-full" />
  <section :class="`bg-${themeColor?.name} text-white`">
    <div class="relative z-20 mx-auto flex size-full max-w-screen-au flex-wrap items-center gap-14 text-clip px-4 pb-10 pt-40 transition-all xs:pb-14 sm:px-8 sm:pt-32">
      <div class="mx-auto w-full space-y-6 md:max-w-[70%] lg:pr-6">
        <div class="flex flex-wrap gap-8">
          <SubscriptionBox v-if="isTeacher" />
          <div class="content-center">
            <h1
              class="sr-only"
              v-text="t('home.title')"
            />
            <p class="fluid-text-lg">
              {{ greeting.text }}<br>
              <span
                v-if="user"
                class="font-calistoga fluid-text-5xl"
                v-text="`${user.firstName}`"
              />
            </p>
          </div>
        </div>
        <UpperPrimarySubjects />
      </div>
      <BannerArticles class="w-full" />
    </div>
  </section>
</template>
